import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';
import { CustomToastService } from '@app-shared/services';

@Component({
  selector: 'modify-dc-process-errors.component',
  templateUrl: './modify-dc-process-errors.component.html',
  styleUrls: ['./modify-dc-process-errors.component.sass']

})

export class ModifyDCProcessErrorsComponent implements OnInit {  
  
  @Input() title: string;
  @Input() cmsModel;
  @Output() goToDcLandingEvent:EventEmitter<boolean> = new EventEmitter<boolean>();
    
  constructor(private router: Router, public activeModal: NgbActiveModal, 
    private modalService: NgbModal,private toastr: CustomToastService) {
  }

  ngOnInit() {
    this.toastr.remove();
  }

  goToDcLanding() {
    this.goToDcLandingEvent.emit(true);
    this.activeModal.close(true)
  }
}

